import { Modal, ModalBody } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import graphHandler from "../../../Apollo/graphHandler";
import { UPDATE_DOMAIN_GQL } from "../../../Apollo/AdminServices/MutationRequest";
import Description from "../../../components/Input/Description";
import { getDescription, IsNullOrEmpty } from "../../../utils/Functions/filter";
import { useEffect } from "react";
import CustomButton from "../../../components/Button/CustomButton";

export default function EditDomainModal({
  isOpen,
  setOpen,
  refresh,
  initialValue = {},
}) {
  const formik = useFormik({
    initialValues: {
      domain_id: initialValue.domain_id,
      domain_name: initialValue.domain_name,
      description: "",
      alias_name: "",
      mobile_description: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  useEffect(() => {
    if (initialValue.domain_id) {
      let value = {
        domain_id: initialValue.domain_id,
        domain_name: initialValue.domain_name,
      };
      if (initialValue.alias_name) {
        value.alias_name = initialValue.alias_name;
      }
      if (!IsNullOrEmpty(initialValue.sort_order)) {
        value.sort_order = initialValue.sort_order;
      }
      if (
        initialValue.domain_description &&
        initialValue.domain_description.length > 0
      ) {
        if (getDescription(initialValue.domain_description, "Web")) {
          value.description = getDescription(
            initialValue.domain_description,
            "Web"
          ).description;
        }
        if (getDescription(initialValue.domain_description, "Mobile")) {
          value.mobile_description = getDescription(
            initialValue.domain_description,
            "Mobile"
          ).description;
        }
      }
      formik.setValues(value);
    }
  }, [initialValue, isOpen]);

  const onClose = () => {
    formik.resetForm();
    setOpen();
  };
  const onSubmit = async (values) => {
    // console.log("Submit", values);
    const {
      alias_name,
      sort_order,
      domain_name,
      domain_id,
      description,
      mobile_description,
    } = values;
    const update_request = {
      domain_id,
      alias_name,
    };
    if (domain_name.trim() !== initialValue.domain_name) {
      update_request.domain_name = domain_name.trim();
    }
    if (
      IsNullOrEmpty(initialValue.sort_order) ||
      sort_order != initialValue.sort_order
    ) {
      update_request.sort_order = Number(sort_order);
    }
    let domain_description = [];
    if (description) {
      domain_description.push({
        client_type: "Web",
        description: description !== "" ? description : "",
      });
    }
    if (mobile_description) {
      domain_description.push({
        client_type: "Mobile",
        description: mobile_description !== "" ? mobile_description : "",
      });
    }
    if (domain_description.length > 0) {
      update_request.domain_description = domain_description;
    } else {
      update_request.domain_description = [];
    }
    try {
      const { data } = await graphHandler().invoke(
        UPDATE_DOMAIN_GQL,
        { update_request },
        1,
        false
      );
      toast.success("Updated Successfully!");
      refresh();
      onClose();
      formik.setSubmitting(false);
    } catch (error) {
      console.log("updateDomain error", error);
      formik.setSubmitting(false);
    }
  };
  const handleError = () => {
    if (Object.keys(formik.errors).length > 0) {
      toast.error(formik.errors[Object.keys(formik.errors)[0]]);
    }
  };
  return (
    <Modal toggle={onClose} isOpen={isOpen} centered size="xl">
      <div className="modal-header">
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">&times;</span>
        </button>
        <h5 className="modal-title">Update Domain</h5>
      </div>
      <ModalBody>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 form-group">
              <label
                htmlFor="domain_name"
                className="col-form-label w-100 mb-2"
              >
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="domain_name"
                name="domain_name"
                value={
                  formik.values && formik.values.domain_name
                    ? formik.values.domain_name
                    : ""
                }
                onChange={(e) =>
                  formik.setFieldValue(
                    "domain_name",
                    e.target.value.trimStart()
                  )
                }
                onBlur={(e) => {
                  formik.setFieldTouched("domain_name", true);
                  formik.setFieldValue(
                    "domain_name",
                    e.target.value.replace(/\s+/g, " ").trim()
                  );
                }}
              />{" "}
              <small className="text-danger">
                {formik.touched.domain_name &&
                formik.errors &&
                formik.errors.domain_name
                  ? formik.errors.domain_name
                  : ""}
              </small>
            </div>
            <div className="col-md-12 form-group">
              <label htmlFor="alias_name" className="col-form-label w-100 mb-2">
                Alias Name
              </label>
              <input
                type="text"
                className="form-control"
                id="alias_name"
                name="alias_name"
                value={
                  formik.values && formik.values.alias_name
                    ? formik.values.alias_name
                    : ""
                }
                // onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                onChange={(e) =>
                  formik.setFieldValue("alias_name", e.target.value.trimStart())
                }
                onBlur={(e) => {
                  formik.setFieldTouched("alias_name", true);
                  formik.setFieldValue(
                    "alias_name",
                    e.target.value.replace(/\s+/g, " ").trim()
                  );
                }}
              />
              <small className="text-danger">
                {formik.touched.alias_name &&
                formik.errors &&
                formik.errors.alias_name
                  ? formik.errors.alias_name
                  : ""}
              </small>
            </div>
            <div className="col-md-12 form-group">
              <label htmlFor="sort_order" className="col-form-label w-100 mb-2">
                Sort Order
              </label>
              <div className="d-flex flex-column p-0">
                <input
                  type="number"
                  className="form-control h-100 w-100"
                  placeholder=""
                  id="sort_order"
                  name="sort_order"
                  max={100}
                  value={
                    formik.values && formik.values.sort_order
                      ? formik.values.sort_order
                      : ""
                  }
                  onBlur={formik.handleBlur}
                  onChange={(e) =>
                    formik.setFieldValue(
                      "sort_order",
                      e.target.value.replace(/[^0-9\.]/g, "")
                    )
                  }
                />
                <small className="text-danger">
                  {formik.touched.sort_order && formik.errors.sort_order
                    ? formik.errors.sort_order
                    : ""}
                </small>
              </div>
            </div>
            <Description formik={formik} />
            <CustomButton
              type="button"
              className="btn btn-primary btn-outline-success float-right btn-add-domain"
              disabled={
                Object.keys(formik.errors).length !== 0 ||
                !formik.isValid ||
                formik.isSubmitting
              }
              onClick={
                formik.isValid && Object.keys(formik.values).length !== 0
                  ? formik.handleSubmit
                  : handleError
              }
            >
              Update
            </CustomButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

const validation = Yup.object().shape({
  domain_name: Yup.string().trim().required("Domain name is required"),
  // .min(4, "Domain name should be min of 4 characters")
  // .max(30, "Domain name should be maximum of 30 characters")
  alias_name: Yup.string().trim(),
  description: Yup.string(),
  mobile_description: Yup.string(),
  sort_order: Yup.string().required("Enter sort order"),
});
